import { render, staticRenderFns } from "./CustomerRecentVisits.vue?vue&type=template&id=8b084678&scoped=true&"
import script from "./CustomerRecentVisits.vue?vue&type=script&lang=js&"
export * from "./CustomerRecentVisits.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRecentVisits.vue?vue&type=style&index=0&id=8b084678&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b084678",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
installComponents(component, {VAvatar,VChip,VChipGroup})
